import { MatInputIntegerDirective } from './input-integer.directive';
import { MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [MatInputIntegerDirective],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule
  ],
  exports: [MatInputIntegerDirective]
})
export class InputIntegerModule { }
